import { IComercioRequest } from "../../../interfaces/IComercioRequest";
import { IReembolsosComerciosRaizenRequest } from "../../../interfaces/IReembolsosComerciosRaizenRequest";
import axios from "axios";

export const obtenerReembolsosComerciosRaizen = async (data:IReembolsosComerciosRaizenRequest) => {
    return axios.post(`api/Reembolso/ObtenerReembolsosComerciosRaizen`,data)
}
export const usuariosObtenerComerciosRaizen = async (data:IComercioRequest) => {
    return axios.post(`api/Reembolso/UsuariosObtenerComerciosRaizen`,data)
}
